import React from 'react'
const Loading = () => {
    return (
        <div className="loader loading-container">
        </div>

    )
}
export default Loading